import { render, staticRenderFns } from "./albumSettings.vue?vue&type=template&id=ef6f5086&"
import script from "./albumSettings.vue?vue&type=script&lang=js&"
export * from "./albumSettings.vue?vue&type=script&lang=js&"
import style0 from "./albumSettings.vue?vue&type=style&index=0&id=ef6f5086&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports